"use client";

import React from "react";
import { Car, MapPin, TrainFront } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const locationData = {
  address: "123 Skyline Avenue, New York, NY 10001",
  mapUrl: "https://maps.google.com/maps?q=123%20Skyline%20Avenue,%20New%20York,%20NY%2010001&t=&z=15&ie=UTF8&iwloc=&output=embed"
};
const infoCards = [{
  title: "Resident Parking",
  description: "Secure underground parking available for all residents. Guest parking is located at the north entrance with 24/7 valet assistance for your visitors.",
  icon: Car
}, {
  title: "Transit Access",
  description: "Perfectly positioned for commuters. The central transit hub is a 3-minute walk, providing direct access to major subway lines and regional rail.",
  icon: TrainFront
}, {
  title: "The Neighborhood",
  description: "Located in the vibrant heart of the city. Enjoy immediate access to premium shopping, gourmet dining, and lush urban parks just steps from your door.",
  icon: MapPin
}];
export default function OurOfficeLocation() {
  const {
    ref: cardsRef,
    isVisible: cardsVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223399" id="our-office-location" className="w-full bg-background text-foreground flex flex-col">
      {}
      <div className="w-full h-[400px] md:h-[500px] lg:h-[600px] relative bg-muted border-b border-border">
        <iframe title="Map of Urban Living Rentals location" src={locationData.mapUrl} className="w-full h-full border-0 grayscale contrast-125 opacity-90 dark:opacity-70 dark:invert dark:hue-rotate-180" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
        {}
        <div className="absolute inset-0 pointer-events-none bg-primary/5 mix-blend-overlay" />
      </div>

      {}
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-foreground mb-4 tracking-tighter">
            Visit Our Leasing Office
          </h2>
          <p className="text-lg text-muted-foreground font-default max-w-2xl mx-auto leading-relaxed">
            Experience Urban Living Rentals in person. Our dedicated team is ready to show you our available residences and premium amenities.
          </p>
        </div>

        <div ref={cardsRef} className={`grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 transition-all duration-1000 ease-out ${cardsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {infoCards.map((card, index) => {
          const Icon = card.icon;
          return <Card key={index} data-index={index} className="bg-card border-border shadow-md hover:shadow-xl transition-shadow duration-400 h-full flex flex-col rounded-md">
                <CardHeader className="pb-4">
                  <div className="w-12 h-12 rounded-md bg-primary/10 flex items-center justify-center mb-4">
                    <Icon className="w-6 h-6 text-primary" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="font-default font-bold text-xl md:text-2xl text-card-foreground tracking-tight">
                    {card.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="pt-0 flex-grow">
                  <p className="text-muted-foreground font-default leading-relaxed">
                    {card.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}